import { Reveal } from "./Reveal";

const problems = [
  {
    n: "01",
    text: "Tu scrolles encore sur ton téléphone à 23h sans réussir à t’arrêter.",
  },
  {
    n: "02",
    text: "Ton esprit tourne en rond dès que tu poses la tête sur l’oreiller.",
  },
  {
    n: "03",
    text: "Tu t’endors épuisé, mais tu te réveilles tout aussi fatigué.",
  },
  {
    n: "04",
    text: "Tu n’arrives pas à déconnecter du travail une fois la journée finie.",
  },
];

export const Problem = () => {
  return (
    <section
      data-testid="problem-section"
      className="relative mx-auto max-w-6xl px-6 py-24 md:py-32 lg:px-10"
    >
      <Reveal>
        <p className="mb-5 text-xs font-semibold uppercase tracking-[0.3em] text-[#c9a84c]">
          Le constat
        </p>
        <h2 className="max-w-2xl text-4xl font-light leading-tight tracking-tight sm:text-5xl">
          Et si tes soirées ressemblaient à ça&nbsp;?
        </h2>
      </Reveal>

      <div className="mt-16 grid gap-px overflow-hidden rounded-2xl border border-white/5 bg-white/5 sm:grid-cols-2">
        {problems.map((p, i) => (
          <Reveal
            key={p.n}
            delay={i * 0.08}
            className="group bg-[#0a0e1a] p-8 transition-colors duration-500 hover:bg-[#140b26] sm:p-10"
          >
            <span className="block text-sm font-light tracking-widest text-[#c9a84c]/70">
              {p.n}
            </span>
            <p className="mt-5 text-lg font-light leading-relaxed text-white/80 sm:text-xl">
              {p.text}
            </p>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1}>
        <p className="mt-14 max-w-xl text-base leading-relaxed text-white/50">
          Tu n’as pas besoin de plus de volonté. Tu as besoin d’un rituel simple,
          nuit après nuit, pour réapprendre à te reposer.
        </p>
      </Reveal>
    </section>
  );
};
